'use strict';

module.exports = {
    server: (
        typeof(process) === 'object' &&
        /(iojs|node)/.test(process.title)
    ),
    client: (typeof(navigator) === 'object')
};
